/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Choose_A_ThemeInputs */

const en_choose_a_theme = /** @type {(inputs: Choose_A_ThemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose a Theme`)
};

const es_choose_a_theme = /** @type {(inputs: Choose_A_ThemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elegir un Tema`)
};

const fr_choose_a_theme = /** @type {(inputs: Choose_A_ThemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choisir un Thème`)
};

const de_choose_a_theme = /** @type {(inputs: Choose_A_ThemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wählen Sie ein Design`)
};

const ja_choose_a_theme = /** @type {(inputs: Choose_A_ThemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`テーマを選択`)
};

const zh_choose_a_theme = /** @type {(inputs: Choose_A_ThemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择主题`)
};

const ar_choose_a_theme = /** @type {(inputs: Choose_A_ThemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اختر سمة`)
};

const id_choose_a_theme = /** @type {(inputs: Choose_A_ThemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pilih Tema`)
};

const it_choose_a_theme = /** @type {(inputs: Choose_A_ThemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scegli un Tema`)
};

const ru_choose_a_theme = /** @type {(inputs: Choose_A_ThemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выбрать Тему`)
};

const pt_choose_a_theme = /** @type {(inputs: Choose_A_ThemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escolher um Tema`)
};

const ko_choose_a_theme = /** @type {(inputs: Choose_A_ThemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`테마 선택`)
};

/**
* | output |
* | --- |
* | "Choose a Theme" |
*
* @param {Choose_A_ThemeInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const choose_a_theme = /** @type {((inputs?: Choose_A_ThemeInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Choose_A_ThemeInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_choose_a_theme(inputs)
	if (locale === "es") return es_choose_a_theme(inputs)
	if (locale === "fr") return fr_choose_a_theme(inputs)
	if (locale === "de") return de_choose_a_theme(inputs)
	if (locale === "ja") return ja_choose_a_theme(inputs)
	if (locale === "zh") return zh_choose_a_theme(inputs)
	if (locale === "ar") return ar_choose_a_theme(inputs)
	if (locale === "id") return id_choose_a_theme(inputs)
	if (locale === "it") return it_choose_a_theme(inputs)
	if (locale === "ru") return ru_choose_a_theme(inputs)
	if (locale === "pt") return pt_choose_a_theme(inputs)
	return ko_choose_a_theme(inputs)
});